import { render, staticRenderFns } from "./PartnerItem.vue?vue&type=template&id=3635325e&scoped=true"
import script from "./PartnerItem.vue?vue&type=script&lang=js"
export * from "./PartnerItem.vue?vue&type=script&lang=js"
import style0 from "./PartnerItem.vue?vue&type=style&index=0&id=3635325e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635325e",
  null
  
)

export default component.exports